export default {
  path: '/test-tables',
  component: () => import('@/components/pages/TestTables/TestTables.vue')
}
